import React from 'react'
import { Outlet } from 'react-router-dom'
import Profilenavbar2 from '../../Component/Profilenavbar2'

const Layout1 = () => {
    return (
        <div className='dashboard'>
            <div className='d-flex w-100'>
                <Profilenavbar2 />
                <div className='dashRightView'>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Layout1